export default [
  {
    "code": "186",
    "name": "Järvenpää",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "149",
    "name": "Inkoo",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 110.00
  },
  {
    "code": "106",
    "name": "Hyvinkää",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 115.00
  },
  {
    "code": "092",
    "name": "Vantaa",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 120.00
  },
  {
    "code": "091",
    "name": "Helsinki",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 120.00
  },
  {
    "code": "078",
    "name": "Hanko",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 105.00
  },
  {
    "code": "049",
    "name": "Espoo",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 118.00
  },
  {
    "code": "710",
    "name": "Raasepori",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 110.00
  },
  {
    "code": "755",
    "name": "Siuntio",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 110.00
  },
  {
    "code": "858",
    "name": "Tuusula",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "927",
    "name": "Vihti",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "018",
    "name": "Askola",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "407",
    "name": "Lapinjärvi",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "434",
    "name": "Loviisa",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "504",
    "name": "Myrskylä",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "616",
    "name": "Pukkila",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "638",
    "name": "Porvoo",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "753",
    "name": "Sipoo",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 100.00
  },
  {
    "code": "543",
    "name": "Nurmijärvi",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 112.00
  },
  {
    "code": "540",
    "name": "Nummi-Pusula",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 105.00
  },
  {
    "code": "611",
    "name": "Pornainen",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 112.00
  },
  {
    "code": "505",
    "name": "Mäntsälä",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 103.00
  },
  {
    "code": "444",
    "name": "Lohja",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 110.00
  },
  {
    "code": "257",
    "name": "Kirkkonummi",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 115.00
  },
  {
    "code": "245",
    "name": "Kerava",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "235",
    "name": "Kauniainen",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 120.00
  },
  {
    "code": "224",
    "name": "Karkkila",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "223",
    "name": "Karjalohja",
    "stateCode": "01",
    "stateName": "Uusimaa",
    "costIndex": 114.00
  },
  {
    "code": "704",
    "name": "Rusko",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "445",
    "name": "Länsi-Turunmaa",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "480",
    "name": "Marttila",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "481",
    "name": "Masku",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "503",
    "name": "Mynämäki",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "529",
    "name": "Naantali",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "538",
    "name": "Nousiainen",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "561",
    "name": "Oripää",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "577",
    "name": "Paimio",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "631",
    "name": "Pyhäranta",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "636",
    "name": "Pöytyä",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "680",
    "name": "Raisio",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "430",
    "name": "Loimaa",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "734",
    "name": "Salo",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "738",
    "name": "Sauvo",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "761",
    "name": "Somero",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "833",
    "name": "Taivassalo",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "838",
    "name": "Tarvasjoki",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "853",
    "name": "Turku",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "895",
    "name": "Uusikaupunki",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "918",
    "name": "Vehmaa",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "019",
    "name": "Aura",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "202",
    "name": "Kaarina",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "284",
    "name": "Koski Tl",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "304",
    "name": "Kustavi",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "322",
    "name": "Kemiönsaari",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "400",
    "name": "Laitila",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "423",
    "name": "Lieto",
    "stateCode": "02",
    "stateName": "Varsinais-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "531",
    "name": "Nakkila",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "484",
    "name": "Merikarvia",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "442",
    "name": "Luvia",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "413",
    "name": "Lavia",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "051",
    "name": "Eurajoki",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "079",
    "name": "Harjavalta",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "099",
    "name": "Honkajoki",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "102",
    "name": "Huittinen",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "181",
    "name": "Jämijärvi",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "214",
    "name": "Kankaanpää",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "230",
    "name": "Karvia",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "254",
    "name": "Kiikoinen",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "271",
    "name": "Kokemäki",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "319",
    "name": "Köyliö",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "050",
    "name": "Eura",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "886",
    "name": "Ulvila",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "783",
    "name": "Säkylä",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "747",
    "name": "Siikainen",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "684",
    "name": "Rauma",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "609",
    "name": "Pori",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "608",
    "name": "Pomarkku",
    "stateCode": "04",
    "stateName": "Satakunta",
    "costIndex": 100.00
  },
  {
    "code": "694",
    "name": "Riihimäki",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "981",
    "name": "Ypäjä",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "834",
    "name": "Tammela",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "433",
    "name": "Loppi",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "169",
    "name": "Jokioinen",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "165",
    "name": "Janakkala",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "109",
    "name": "Hämeenlinna",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "103",
    "name": "Humppila",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "086",
    "name": "Hausjärvi",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "082",
    "name": "Hattula",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "061",
    "name": "Forssa",
    "stateCode": "05",
    "stateName": "Kanta-Häme",
    "costIndex": 100.00
  },
  {
    "code": "020",
    "name": "Akaa",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "108",
    "name": "Hämeenkyrö",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "143",
    "name": "Ikaalinen",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "177",
    "name": "Juupajoki",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "211",
    "name": "Kangasala",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "250",
    "name": "Kihniö",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "418",
    "name": "Lempäälä",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "508",
    "name": "Mänttä-Vilppula",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "536",
    "name": "Nokia",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "980",
    "name": "Ylöjärvi",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "936",
    "name": "Virrat",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "922",
    "name": "Vesilahti",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "908",
    "name": "Valkeakoski",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "887",
    "name": "Urjala",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "837",
    "name": "Tampere",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "790",
    "name": "Sastamala",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "702",
    "name": "Ruovesi",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "635",
    "name": "Pälkäne",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "619",
    "name": "Punkalaidun",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "604",
    "name": "Pirkkala",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "562",
    "name": "Orivesi",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "581",
    "name": "Parkano",
    "stateCode": "06",
    "stateName": "Pirkanmaa",
    "costIndex": 100.00
  },
  {
    "code": "532",
    "name": "Nastola",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "398",
    "name": "Lahti",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "316",
    "name": "Kärkölä",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "283",
    "name": "Hämeenkoski",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "111",
    "name": "Heinola",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "098",
    "name": "Hollola",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "081",
    "name": "Hartola",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "016",
    "name": "Asikkala",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "781",
    "name": "Sysmä",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "576",
    "name": "Padasjoki",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "560",
    "name": "Orimattila",
    "stateCode": "07",
    "stateName": "Päijät-Häme",
    "costIndex": 100.00
  },
  {
    "code": "935",
    "name": "Virolahti",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "286",
    "name": "Kouvola",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "285",
    "name": "Kotka",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "142",
    "name": "Iitti",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "075",
    "name": "Hamina",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "624",
    "name": "Pyhtää",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "489",
    "name": "Miehikkälä",
    "stateCode": "08",
    "stateName": "Kymenlaakso",
    "costIndex": 100.00
  },
  {
    "code": "689",
    "name": "Rautjärvi",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "580",
    "name": "Parikkala",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "416",
    "name": "Lemi",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "441",
    "name": "Luumäki",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "405",
    "name": "Lappeenranta",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "153",
    "name": "Imatra",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "831",
    "name": "Taipalsaari",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "775",
    "name": "Suomenniemi",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "739",
    "name": "Savitaipale",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "700",
    "name": "Ruokolahti",
    "stateCode": "09",
    "stateName": "Etelä-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "090",
    "name": "Heinävesi",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "046",
    "name": "Enonkoski",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "097",
    "name": "Hirvensalmi",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "171",
    "name": "Joroinen",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "178",
    "name": "Juva",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "213",
    "name": "Kangasniemi",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "246",
    "name": "Kerimäki",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "491",
    "name": "Mikkeli",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "507",
    "name": "Mäntyharju",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "588",
    "name": "Pertunmaa",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "593",
    "name": "Pieksämäki",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "618",
    "name": "Punkaharju",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "623",
    "name": "Puumala",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "681",
    "name": "Rantasalmi",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "696",
    "name": "Ristiina",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "740",
    "name": "Savonlinna",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "768",
    "name": "Sulkava",
    "stateCode": "10",
    "stateName": "Etelä-Savo",
    "costIndex": 100.00
  },
  {
    "code": "140",
    "name": "Iisalmi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "925",
    "name": "Vieremä",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "174",
    "name": "Juankoski",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "204",
    "name": "Kaavi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "239",
    "name": "Keitele",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "263",
    "name": "Kiuruvesi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "297",
    "name": "Kuopio",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "402",
    "name": "Lapinlahti",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "420",
    "name": "Leppävirta",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "476",
    "name": "Maaninka",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "534",
    "name": "Nilsiä",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "595",
    "name": "Pielavesi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "686",
    "name": "Rautalampi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "687",
    "name": "Rautavaara",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "749",
    "name": "Siilinjärvi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "762",
    "name": "Sonkajärvi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "778",
    "name": "Suonenjoki",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "844",
    "name": "Tervo",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "857",
    "name": "Tuusniemi",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "915",
    "name": "Varkaus",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "921",
    "name": "Vesanto",
    "stateCode": "11",
    "stateName": "Pohjois-Savo",
    "costIndex": 100.00
  },
  {
    "code": "707",
    "name": "Rääkkylä",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "911",
    "name": "Valtimo",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "146",
    "name": "Ilomantsi",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "167",
    "name": "Joensuu",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "176",
    "name": "Juuka",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "248",
    "name": "Kesälahti",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "260",
    "name": "Kitee",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "276",
    "name": "Kontiolahti",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "309",
    "name": "Outokumpu",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "422",
    "name": "Lieksa",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "426",
    "name": "Liperi",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "541",
    "name": "Nurmes",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "607",
    "name": "Polvijärvi",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "848",
    "name": "Tohmajärvi",
    "stateCode": "12",
    "stateName": "Pohjois-Karjala",
    "costIndex": 100.00
  },
  {
    "code": "291",
    "name": "Kuhmoinen",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "182",
    "name": "Jämsä",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "216",
    "name": "Kannonkoski",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "226",
    "name": "Karstula",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "249",
    "name": "Keuruu",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "256",
    "name": "Kinnula",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "265",
    "name": "Kivijärvi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "275",
    "name": "Konnevesi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "312",
    "name": "Kyyjärvi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "410",
    "name": "Laukaa",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "435",
    "name": "Luhanka",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "495",
    "name": "Multia",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "500",
    "name": "Muurame",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "592",
    "name": "Petäjävesi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "601",
    "name": "Pihtipudas",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "729",
    "name": "Saarijärvi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "850",
    "name": "Toivakka",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "892",
    "name": "Uurainen",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "931",
    "name": "Viitasaari",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "992",
    "name": "Äänekoski",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "077",
    "name": "Hankasalmi",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "172",
    "name": "Joutsa",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "179",
    "name": "Jyväskylä",
    "stateCode": "13",
    "stateName": "Keski-Suomi",
    "costIndex": 100.00
  },
  {
    "code": "989",
    "name": "Ähtäri",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "408",
    "name": "Lapua",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "743",
    "name": "Seinäjoki",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "759",
    "name": "Soini",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "846",
    "name": "Teuva",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "863",
    "name": "Töysä",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "005",
    "name": "Alajärvi",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "010",
    "name": "Alavus",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "052",
    "name": "Evijärvi",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "145",
    "name": "Ilmajoki",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "151",
    "name": "Isojoki",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "934",
    "name": "Vimpeli",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "164",
    "name": "Jalasjärvi",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "218",
    "name": "Karijoki",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "232",
    "name": "Kauhajoki",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "233",
    "name": "Kauhava",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "300",
    "name": "Kuortane",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "301",
    "name": "Kurikka",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "403",
    "name": "Lappajärvi",
    "stateCode": "14",
    "stateName": "Etelä-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "905",
    "name": "Vaasa",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "946",
    "name": "Vyöri",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "942",
    "name": "Vähäkyrö",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "893",
    "name": "Uusikaarlepyy",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "599",
    "name": "Pedersören kunta",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "598",
    "name": "Pietarsaari",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "545",
    "name": "Närpiö",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "499",
    "name": "Mustasaari",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "475",
    "name": "Maalahti",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "440",
    "name": "Luoto",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "399",
    "name": "Laihia",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "288",
    "name": "Kruunupyy",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "287",
    "name": "Kristiinankaupunki",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "280",
    "name": "Korsnäs",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "231",
    "name": "Kaskinen",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "152",
    "name": "Isokyrö",
    "stateCode": "15",
    "stateName": "Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "272",
    "name": "Kokkola",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "421",
    "name": "Lestijärvi",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "849",
    "name": "Toholampi",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "584",
    "name": "Perho",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "924",
    "name": "Veteli",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "074",
    "name": "Halsua",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "217",
    "name": "Kannus",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "236",
    "name": "Kaustinen",
    "stateCode": "16",
    "stateName": "Keski-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "009",
    "name": "Alavieska",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "305",
    "name": "Kuusamo",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "317",
    "name": "Kärsämäki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "425",
    "name": "Liminka",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "436",
    "name": "Lumijoki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "483",
    "name": "Merijärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "494",
    "name": "Muhos",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "535",
    "name": "Nivala",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "563",
    "name": "Oulainen",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "564",
    "name": "Oulu",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "567",
    "name": "Oulunsalo",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "615",
    "name": "Pudasjärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "625",
    "name": "Pyhäjoki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "626",
    "name": "Pyhäjärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "630",
    "name": "Pyhäntä",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "678",
    "name": "Raahe",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "691",
    "name": "Reisjärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "746",
    "name": "Sievi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "748",
    "name": "Siikajoki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "791",
    "name": "Siikalatva",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "832",
    "name": "Taivalkoski",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "859",
    "name": "Tyrnävä",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "889",
    "name": "Utajärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "926",
    "name": "Vihanti",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "972",
    "name": "Yli-Ii",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "255",
    "name": "Kiiminki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "977",
    "name": "Ylivieska",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "244",
    "name": "Kempele",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "208",
    "name": "Kalajoki",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "139",
    "name": "Ii",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "084",
    "name": "Haukipudas",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "072",
    "name": "Hailuoto",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "071",
    "name": "Haapavesi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "069",
    "name": "Haapajärvi",
    "stateCode": "17",
    "stateName": "Pohjois-Pohjanmaa",
    "costIndex": 100.00
  },
  {
    "code": "777",
    "name": "Suomussalmi",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "785",
    "name": "Vaala",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "765",
    "name": "Sotkamo",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "697",
    "name": "Ristijärvi",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "620",
    "name": "Puolanka",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "578",
    "name": "Paltamo",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "290",
    "name": "Kuhmo",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "205",
    "name": "Kajaani",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "105",
    "name": "Hyrynsalmi",
    "stateCode": "18",
    "stateName": "Kainuu",
    "costIndex": 100.00
  },
  {
    "code": "148",
    "name": "Inari",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "240",
    "name": "Kemi",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "241",
    "name": "Keminmaa",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "261",
    "name": "Kittilä",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "273",
    "name": "Kolari",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "320",
    "name": "Kemijärvi",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "498",
    "name": "Muonio",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "583",
    "name": "Pelkosenniemi",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "614",
    "name": "Posio",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "047",
    "name": "Enontekiö",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "683",
    "name": "Ranua",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "698",
    "name": "Rovaniemi",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "732",
    "name": "Salla",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "742",
    "name": "Savukoski",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "751",
    "name": "Simo",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "758",
    "name": "Sodankylä",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "845",
    "name": "Tervola",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "851",
    "name": "Tornio",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "854",
    "name": "Pello",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "890",
    "name": "Utsjoki",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "976",
    "name": "Ylitornio",
    "stateCode": "19",
    "stateName": "Lappi",
    "costIndex": 100.00
  },
  {
    "code": "417",
    "name": "Lemland",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "035",
    "name": "Brändö",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "043",
    "name": "Eckerö",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "478",
    "name": "Maarianhamina - Mariehamn",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "736",
    "name": "Saltvik",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "766",
    "name": "Sottunga",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "771",
    "name": "Sund",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "941",
    "name": "Vårdö",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "060",
    "name": "Finström",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "062",
    "name": "Föglö",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "065",
    "name": "Geta",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "076",
    "name": "Hammarland",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "170",
    "name": "Jomala",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "295",
    "name": "Kumlinge",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "318",
    "name": "Kökar",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  },
  {
    "code": "438",
    "name": "Lumparland",
    "stateCode": "21",
    "stateName": "Ahvenanmaa - Åland",
    "costIndex": 100.00
  }
]



// WEBPACK FOOTER //
// ./src/api/towns.js